// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"28183":"b1cfe37b7e75d043","45773":"7c2f25dba039f6ac"}[chunkId] + ".css";
};